// TODO: delet comented imports

import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainLayout from "../layouts/MainLayout/MainLayout";
import SignUpPage from "../../pages/SignUpPage";
import AuthLayoutFallback from "../layouts/AuthLayoutFallback";
import InscriptionForm from "../signupform/InscriptionForm";
import LoginPage from "../../pages/LoginPage";
import ProfileLayout from "../layouts/profileLayout/ProfileLayout";
import Welcome from "../Welcome";
import PersonalInfo from "../profile/PersonalInfo";
import SecuritySettings from "../profile/SecuritySettings";
import Notifications from "../profile/Notifications";
import Payments from "../profile/Payments";
import RequiredAuth from "./RequiredAuth";
import ForgetPasswordForm from "../loginForm/ForgetPasswordForm";
import NotFound from "../../pages/NotFound";
import { auth } from "../../config/firebase";
import { userState } from "../../store/slices/loginSlice";
import {
  getCourses,
  getUser,
  signOut,
  updateUser,
} from "../../hooks/useSignup";
import store from "../../store/store";
import FInishInscriptionPage from "../signupform/FInishInscriptionPage";

export const AppRouter = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [user, setuser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      await getCourses();
      if (user) {
        const { emailVerified, uid, email } = user;
        await updateUser(uid, emailVerified, email);
        const logedInUser = await getUser(uid);
        if (logedInUser?.role !== "student") {
          signOut();
          setuser(null);
          setIsLoading(false);
        } else {
          store.dispatch(userState({ ...logedInUser, uid }));
          setuser({
            uid,
          });
          setIsLoading(false);
        }
      } else {
        setuser(null);
        setIsLoading(false);
      }
    });
    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ProtectedLayout = (
    <RequiredAuth isLoading={isLoading} user={user}>
      <MainLayout />
    </RequiredAuth>
  );
  return (
    <BrowserRouter>
      <Routes>
        {/* <Route path={NFT_DASHBOARD_PATH} element={protectedLayout}> */}
        <Route path={`/`} element={ProtectedLayout}>
          <Route index element={<Welcome />} />
          {/* <Route path={MEDICAL_DASHBOARD_PATH} element={<MedicalDashboard />} /> */}
          <Route path="profile" element={<ProfileLayout />}>
            <Route path="personal-info" element={<PersonalInfo />} />
            <Route path="security-settings" element={<SecuritySettings />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="payments" element={<Payments />} />
          </Route>
          {/* <Route path="apps">
            <Route path="feed" element={<NewsFeed />} />
          </Route>
          <Route path="forms">
            <Route path="advanced-forms" element={<AdvancedForm />} />
          </Route>
          <Route path="data-tables" element={<DataTables />} />
          <Route path="charts" element={<Charts />} />
          <Route path="maps">
            <Route path="google-maps" element={<Google />} />
            <Route path="leaflet-maps" element={<Leaflet />} />
            <Route path="react-simple-maps" element={<ReactSimple />} />
            <Route path="pigeon-maps" element={<Pigeons />} />
          </Route>
          <Route path="server-error" element={<ServerError />} />
          <Route path="404" element={<Error404 />} />
         
          <Route path="ui-components">
            <Route path="button" element={<Buttons />} />
            <Route path="spinner" element={<Spinners />} />
            <Route path="input" element={<Inputs />} />
            <Route path="checkbox" element={<Checkboxes />} />
            <Route path="radio" element={<Radios />} />
            <Route path="select" element={<Selects />} />
            <Route path="switch" element={<Switches />} />
            <Route path="upload" element={<Uploads />} />
            <Route path="rate" element={<Rates />} />
            <Route path="auto-complete" element={<AutoCompletes />} />
            <Route path="steps" element={<Steps />} />
            <Route path="date-time-picker" element={<DateTimePickers />} />
            <Route path="dropdown" element={<Dropdowns />} />
            <Route path="breadcrumbs" element={<Breadcrumbs />} />
            <Route path="tabs" element={<Tabs />} />
            <Route path="avatar" element={<Avatars />} />
            <Route path="badge" element={<Badges />} />
            <Route path="collapse" element={<Collapse />} />
            <Route path="pagination" element={<Pagination />} />
            <Route path="modal" element={<Modals />} />
            <Route path="popover" element={<Popovers />} />
            <Route path="popconfirm" element={<Popconfirms />} />
            <Route path="progress" element={<Progress />} />
            <Route path="result" element={<Results />} />
            <Route path="alert" element={<Alerts />} />
            <Route path="notification" element={<NotificationsUI />} />
            <Route path="skeleton" element={<Skeletons />} />
          </Route> */}
        </Route>
        <Route
          path="/auth"
          element={<AuthLayoutFallback isLoading={isLoading} user={user} />}
        >
          {/* <Route path="login" element={<LoginPage />} /> */}
          <Route path="signup" element={<SignUpPage />} />
          <Route path="inscription" element={<InscriptionForm />} />
          <Route
            path="finish-inscription"
            element={<FInishInscriptionPage />}
          />
          <Route path="login" element={<LoginPage />} />
          <Route path="forgotpassword" element={<ForgetPasswordForm />} />
          {/* <Route
            path="lock"
            element={
              <RequireAuth>
                <LockPage />
              </RequireAuth>
            }
          /> */}

          {/* <Route path="security-code" element={<SecurityCodePage />} />
          <Route path="new-password" element={<NewPasswordPage />} /> */}
        </Route>

        <Route path="/*" element={<NotFound />} />
        {/* <Route path="/logout" element={<LogoutFallback />} /> */}
      </Routes>
    </BrowserRouter>
  );
};
